 
 type Category = {
    category:string,
    value:string
 }
const categories:Category[] = [
{
    category:"JavaScript",
    value:"JavaScript"
},
{
    category:"React",
    value:"React"
},
{
    category:"Node",
    value:"Node"
},
{
    category:"Html",
    value:"Html"
}

 ]

 export default categories;